import { Link } from "react-router-dom";
import {
  ArrowRight,
  ChevronDown,
  Wallet,
  TrendingDown,
  Boxes,
  FileText,
  LifeBuoy,
  Home,
  ShoppingCart,
  Users,
} from "lucide-react";
import { CORE_MODULES } from "../moduleData";

const text = (value, lang) => value?.[lang] || value?.tr || "";
export const CORE_ICONS = {
  "on-muhasebe": Wallet,
  "gelir-gider-takibi": TrendingDown,
  "stok-yonetimi": Boxes,
  "teklif-yonetimi": FileText,
  "canli-destek": LifeBuoy,
};

const MenuItem = ({ to, icon: Icon, title, sub, testid, highlight = false }) => (
  <Link
    to={to}
    data-testid={testid}
    className={`flex items-center gap-3 rounded-2xl px-3 py-2.5 transition-all duration-200 hover:-translate-y-0.5 ${
      highlight ? "bg-operofy-blue/10 text-operofy-blue hover:bg-operofy-blue/15" : "text-white/75 hover:bg-white/5 hover:text-white"
    }`}
  >
    <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${highlight ? "bg-operofy-blue text-operofy-onblue" : "bg-white/5 text-operofy-blue"}`}>
      <Icon size={16} strokeWidth={1.8} />
    </span>
    <span className="min-w-0">
      <span className="block truncate text-sm font-bold">{title}</span>
      {sub && <span className="block truncate text-[11px] opacity-60">{sub}</span>}
    </span>
  </Link>
);

export const ModulesMegaMenu = ({ label, lang }) => (
  <div className="group relative" data-testid="modules-mega-menu">
    <Link
      to="/moduller"
      data-testid="nav-moduller"
      className="flex items-center gap-1.5 px-2 py-2 text-sm font-semibold text-white/70 transition-colors duration-200 hover:text-operofy-blue"
    >
      {label}
      <ChevronDown size={14} strokeWidth={2} className="transition-transform duration-200 group-hover:rotate-180" />
    </Link>
    <div className="invisible absolute left-1/2 top-full -translate-x-1/2 pt-4 opacity-0 transition-all duration-200 group-hover:visible group-hover:opacity-100">
      <div className="grid w-[720px] grid-cols-2 gap-4 rounded-[1.75rem] border border-white/10 bg-operofy-darksurface p-5 shadow-2xl" data-testid="modules-mega-panel">
        <div>
          <Link
            to="/moduller?plan=all"
            data-testid="modules-mega-included"
            className="flex items-center justify-between rounded-2xl bg-operofy-blue/10 px-4 py-3 font-mono-tech text-[10px] tracking-[0.18em] text-operofy-blue transition-colors hover:bg-operofy-blue/20"
          >
            {lang === "en" ? "INCLUDED IN PLANS" : "PAKETLERE DAHİL"}
            <ArrowRight size={13} />
          </Link>
          <div className="mt-3 space-y-1">
            {CORE_MODULES.map((item) => (
              <MenuItem
                key={item.slug}
                to={item.href}
                icon={CORE_ICONS[item.slug] || Wallet}
                title={text(item.title, lang)}
                sub={text(item.coverage, lang)}
                testid={`mega-included-${item.slug}`}
              />
            ))}
          </div>
        </div>
        <div>
          <Link
            to="/karsilastir"
            data-testid="modules-mega-plans"
            className="flex items-center justify-between rounded-2xl bg-white/5 px-4 py-3 font-mono-tech text-[10px] tracking-[0.18em] text-white/70 transition-colors hover:bg-white/10 hover:text-white"
          >
            {lang === "en" ? "PLANS" : "PAKETLER"}
            <ArrowRight size={13} />
          </Link>
          <div className="mt-3 space-y-1">
            <MenuItem
              to="/home-plus"
              icon={Home}
              title="Home+"
              sub={lang === "en" ? "Included with Plus" : "Plus ile dahil"}
              testid="mega-home-plus"
              highlight
            />
            <MenuItem
              to="/paket/parasyo-esnaf"
              icon={ShoppingCart}
              title="Premium"
              sub={lang === "en" ? "POS & e-Invoice included" : "POS ve e-Fatura dahil"}
              testid="mega-plan-esnaf"
            />
            <MenuItem
              to="/paket/parasyo-pro"
              icon={Users}
              title="Pro"
              sub={lang === "en" ? "CRM, DMS ve İK+ dahil" : "CRM, DMS and HR+ included"}
              testid="mega-plan-pro"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);
